import PropTypes from 'prop-types'
import { transformAmount } from '@/utils/string-format-utils'

const Amount = ({ amount, sign, color, customColor }) => {
  // Function to determine text color based on the value
  const textColorSelector = () => {
    if (customColor) return customColor
    if (color === 'GRAY' || (amount && amount === 0)) return 'text-dGray-600'
    if (amount && sign && sign === 'NEGATIVE') return 'text-success-600'
    return 'text-dGray-600'
  }

  return (
    <span className={`font-semibold text-left justify-end text-nowrap text-sm ${textColorSelector()}`}>
      {transformAmount(amount, sign)}
    </span>
  )
}

Amount.propTypes = {
  amount: PropTypes.number.isRequired,
  sign: PropTypes.string,
  color: PropTypes.string,
  customColor: PropTypes.string,
}

export default Amount
